import { connect } from 'react-redux';
import ChatbotWidget from '../components/ChatbotWidget/ChatbotWidget';
import actions from '../../actions';

const mapStateToProps = (state) => ({
  isOpen: state.chatbot.isOpen,
  messages: state.chatbot.messages,
  isTyping: state.chatbot.isTyping,
  locale: state.i18n.locale,
  currentStep: state.chatbot.currentStep,
  currentSection: state.chatbot.currentSection,
  currentQuestion: state.chatbot.currentQuestion,
  confirmationTimer: state.chatbot.confirmationTimer,
  contactForm: state.chatbot.contactForm,
  account: state.session.user?.account,
  branch: state.session.user?.branch,
  userGroups: state.session.user?.groups || [],
  isContactSubmitting: state.chatbot.isContactSubmitting,
  contactError: state.chatbot.contactError,
});

const mapDispatchToProps = (dispatch) => ({
  toggle: (isOpen) => dispatch(actions.chatbot.toggle(isOpen)),
  navigate: (step, section, question) =>
    dispatch(actions.chatbot.navigate(step, section, question)),
  goBack: () => dispatch(actions.chatbot.goBack()),
  selectMenuOption: (sectionId, label) =>
    dispatch(actions.chatbot.selectMenuOption(sectionId, label)),
  selectQuestion: (questionId, label) =>
    dispatch(actions.chatbot.selectQuestion(questionId, label)),
  submitContact: (email, reason) =>
    dispatch(actions.chatbot.submitContact(email, reason)),
  startChat: () => dispatch(actions.chatbot.startChat()),
  goToMenu: () => dispatch(actions.chatbot.goToMenu()),
  goToContact: () => dispatch(actions.chatbot.goToContact()),
  loadHistory: (data) => dispatch(actions.chatbot.loadHistory(data)),
  clearHistory: () => dispatch(actions.chatbot.clearHistory()),
});

export default connect(mapStateToProps, mapDispatchToProps)(ChatbotWidget);
